import React from 'react'

const AuthoriseIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_259_5138)">
        <rect x="2" y="1" width="42" height="42" rx="10" fill="#FAFAFB" />
        <path
          d="M19.2843 28.6359C19.4943 28.5129 19.7238 28.3929 19.9728 28.2789C19.7625 28.5925 19.5372 28.8959 19.2978 29.1879C18.8778 29.6934 18.5508 29.9619 18.3453 30.0459C18.3282 30.0531 18.3107 30.0591 18.2928 30.0639C18.2778 30.0431 18.2648 30.021 18.2538 29.9979C18.1698 29.8329 18.1728 29.6739 18.3138 29.4579C18.4728 29.2104 18.7923 28.9269 19.2843 28.6359ZM22.9668 26.1654C22.7883 26.2029 22.6113 26.2404 22.4328 26.2824C22.6972 25.7644 22.9473 25.2392 23.1828 24.7074C23.4199 25.1468 23.6751 25.5762 23.9478 25.9944C23.6223 26.0424 23.2938 26.0994 22.9668 26.1654ZM26.7543 27.5739C26.5213 27.386 26.3032 27.1804 26.1018 26.9589C26.4438 26.9664 26.7528 26.9919 27.0198 27.0399C27.4953 27.1254 27.7188 27.2604 27.7968 27.3534C27.8214 27.3794 27.8353 27.4137 27.8358 27.4494C27.8305 27.5552 27.7997 27.6582 27.7458 27.7494C27.7156 27.8225 27.667 27.8866 27.6048 27.9354C27.5738 27.9544 27.5374 27.9623 27.5013 27.9579C27.3663 27.9534 27.1143 27.8589 26.7543 27.5739ZM23.4168 20.4549C23.3568 20.8209 23.2548 21.2409 23.1168 21.6984C23.066 21.5271 23.0214 21.354 22.9833 21.1794C22.8693 20.6499 22.8528 20.2344 22.9143 19.9464C22.9713 19.6809 23.0793 19.5744 23.2083 19.5219C23.2775 19.4914 23.3508 19.4712 23.4258 19.4619C23.4453 19.5069 23.4678 19.5999 23.4738 19.7589C23.4813 19.9419 23.4633 20.1744 23.4168 20.4564V20.4549Z"
          fill="#CCCFD6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 10H24.9395C25.3373 10.0001 25.7188 10.1582 26 10.4395L31.5605 16C31.8418 16.2812 31.9999 16.6627 32 17.0605V31C32 31.7956 31.6839 32.5587 31.1213 33.1213C30.5587 33.6839 29.7956 34 29 34H17C16.2044 34 15.4413 33.6839 14.8787 33.1213C14.3161 32.5587 14 31.7956 14 31V13C14 12.2044 14.3161 11.4413 14.8787 10.8787C15.4413 10.3161 16.2044 10 17 10V10ZM25.25 12.25V15.25C25.25 15.6478 25.408 16.0294 25.6893 16.3107C25.9706 16.592 26.3522 16.75 26.75 16.75H29.75L25.25 12.25ZM17.2475 30.502C17.3825 30.772 17.5925 31.0165 17.9045 31.1305C18.215 31.243 18.5225 31.1905 18.7745 31.0855C19.2515 30.8905 19.727 30.4315 20.1635 29.9065C20.663 29.305 21.188 28.516 21.695 27.6415C22.6738 27.3514 23.6761 27.1476 24.6905 27.0325C25.1405 27.607 25.6055 28.102 26.0555 28.4575C26.4755 28.7875 26.96 29.062 27.4565 29.083C27.7269 29.0964 27.9947 29.0239 28.2215 28.876C28.454 28.7245 28.6265 28.5055 28.7525 28.252C28.8875 27.9805 28.97 27.697 28.9595 27.4075C28.95 27.1221 28.8443 26.8482 28.6595 26.6305C28.3205 26.2255 27.7655 26.0305 27.2195 25.933C26.5572 25.8304 25.8851 25.8052 25.217 25.858C24.6528 25.0604 24.1608 24.214 23.747 23.329C24.122 22.339 24.4025 21.403 24.527 20.638C24.581 20.311 24.6095 19.999 24.599 19.717C24.5971 19.4371 24.532 19.1612 24.4085 18.91C24.3373 18.7714 24.2362 18.6503 24.1125 18.5556C23.9887 18.4609 23.8454 18.3949 23.693 18.3625C23.39 18.298 23.078 18.3625 22.7915 18.478C22.226 18.703 21.9275 19.183 21.815 19.7125C21.7055 20.2225 21.755 20.8165 21.884 21.4165C22.016 22.0255 22.241 22.6885 22.529 23.359C22.0683 24.5047 21.5363 25.6204 20.936 26.6995C20.163 26.9427 19.4178 27.267 18.713 27.667C18.158 27.997 17.6645 28.387 17.3675 28.8475C17.0525 29.3365 16.955 29.9185 17.2475 30.502Z"
          fill="#CCCFD6"
        />
        <rect
          x="2.5"
          y="1.5"
          width="41"
          height="41"
          rx="9.5"
          stroke="#E6E7EA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_259_5138"
          x="0"
          y="0"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_259_5138"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_259_5138"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default AuthoriseIcon
